var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTajikistan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_34517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.19072 6.78262C0.427875 8.36025 0 10.1302 0 12C0 13.8698 0.427875 15.6397 1.19072 17.2174L12 18.2609L22.8093 17.2174C23.5721 15.6397 24 13.8698 24 12C24 10.1302 23.5721 8.36025 22.8093 6.78262L12 5.73914L1.19072 6.78262Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.19141 17.2174C3.13236 21.2313 7.24278 24 12.0003 24C16.7577 24 20.8682 21.2313 22.8091 17.2174H1.19141Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.19141 6.78263H22.8091C20.8682 2.76872 16.7577 0 12.0003 0C7.24278 0 3.13236 2.76872 1.19141 6.78263Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.91309 15.1305H14.087V13.3565L13.2522 13.7739L12.0001 12.5217L10.7479 13.7739L9.91309 13.3565V15.1305Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.52504 13.0435L7.71934 13.6413H8.34793L7.83934 14.0108L8.03363 14.6087L7.52504 14.2392L7.01645 14.6087L7.21074 14.0108L6.70215 13.6413H7.33074L7.52504 13.0435Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.12758 10.9565L8.32187 11.5544H8.95047L8.44187 11.9239L8.63612 12.5217L8.12758 12.1523L7.61898 12.5217L7.81328 11.9239L7.30469 11.5544H7.93328L8.12758 10.9565Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.84926 9.39136L10.0436 9.9892H10.6721L10.1636 10.3587L10.3578 10.9566L9.84926 10.5871L9.34071 10.9566L9.53496 10.3587L9.02637 9.9892H9.65501L9.84926 9.39136Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4752 13.0435L16.2809 13.6413H15.6523L16.1609 14.0108L15.9666 14.6087L16.4752 14.2392L16.9838 14.6087L16.7895 14.0108L17.2981 13.6413H16.6695L16.4752 13.0435Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8727 10.9565L15.6784 11.5544H15.0498L15.5584 11.9239L15.3641 12.5217L15.8727 12.1523L16.3813 12.5217L16.187 11.9239L16.6956 11.5544H16.067L15.8727 10.9565Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.151 9.39136L13.9567 9.9892H13.3281L13.8366 10.3587L13.6424 10.9566L14.151 10.5871L14.6595 10.9566L14.4653 10.3587L14.9738 9.9892H14.3452L14.151 9.39136Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9996 8.60864L12.1939 9.20649H12.8225L12.3139 9.576L12.5082 10.1738L11.9996 9.80438L11.4911 10.1738L11.6854 9.576L11.1768 9.20649H11.8054L11.9996 8.60864Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_34517"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

export default __webpack_public_path__ + "media/638e4957.svg";
export { SvgTajikistan as ReactComponent };